import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { useStyletron } from "baseui";
import { useParams } from "react-router-dom";
import { Notification } from 'baseui/notification';
import { Alert } from 'baseui/icon';

import {
  COMTEXT_MENU_ACTIONS,
  TREE_ITEM_TYPES,
} from "../../constants/AppEnums";
import TreeSidebar from "../../components/tree-side-bar/TreeSidebar";
import {
  setSelectedParameter,
  setSelectedGroup,
  updateSelectedGroup,
} from "../../redux/template/TemplateActions";
import {
  createParameterGroup,
  deleteParameterGroup,
  deleteParameterItem,
} from "../../redux/template/TemplateThunk";
import { convertFolderToLabel } from "../../components/tree-item/TreeItem";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import ROUTES_PATH from "../../constants/RouteConstants";
import { Input, SIZE } from "baseui/input";
import { Button, SHAPE } from "baseui/button";
import { Plus } from "baseui/icon";
import { styled } from "baseui";
import EmptyListNotificationComponent from "../../components/empty-list-notification/EmptyListNotificationComponent";

const AddGroupArea = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

function TemplateParameterTreeSidebar(props) {
  const [css, theme] = useStyletron();
  const [childKey, setitemschildKey] = useState(7);
  const [groupName, setGroupName] = useState("");
  const { templateId } = useParams();
  const [paramGroups, setParamGroups] = useState(props.groups);
  const [groupNameError, setGroupNameError] = useState(false);
  const onContextMenuItemClick = ({ action, node }) => {
    if (action.action === COMTEXT_MENU_ACTIONS.DELETE) {
      if (node.type === TREE_ITEM_TYPES.GROUP) {
        props.ondeleteTemplateParameterGroup(node.id);
      } else {
        props.ondeleteTemplateParameterItem(node.id);
      }
    }
    props.onItemsChanged();
  };
  const handleLeafNodeClick = (node) => {
    if(props.inProgress) return;
    props.onSetSelectedTemplateItem(node);
    props.onItemsChanged();
  };
  const handleParentNodeClick = (node) => {
    if(props.inProgress) return;
    props.onSetSelectedGroupItem(node);
    props.onItemsChanged();
  };

  const handleAddNewGroup = () => {
    if(!groupName.trim()){
      setGroupNameError(true);
      return
    }
    props.oncreateParameterGroup(templateId, groupName);
    setGroupName("");
    setGroupNameError(false);
  };

  useEffect(() => {
    setParamGroups(props.groups);
    setitemschildKey(childKey * 89);
  }, [props.groups, props.selectedGroup, props.updated]);

  return (
    <Fragment>
      <AddGroupArea>
        <Input
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          size={SIZE.mini}
          placeholder="Enter group name ..."
          error={groupNameError}
          startEnhancer={() => (
            <Button
              onClick={handleAddNewGroup}
              shape={SHAPE.square}
              size={SIZE.mini}
              disabled={props.inProgress}
            >
              <Plus />
            </Button>
          )}
          overrides={{
            StartEnhancer: {
              style: ({ $theme }) => ({
                paddingLeft: $theme.sizing.scale0 // Adjust this value to your liking
              })
            }
          }}          
        />
      </AddGroupArea>
      {paramGroups && paramGroups.length > 0 ? (
        <TreeSidebar
          key={childKey}
          treeData={convertFolderToLabel(
            paramGroups,
            onContextMenuItemClick,
            null,
            () => {},
            false
          )}
          onLeafNodeClicked={(node) => handleLeafNodeClick(node)}
          onParentNodeClicked={(node) => handleParentNodeClick(node)}
        ></TreeSidebar>
      ) : 
      (
       <EmptyListNotificationComponent message="No groups have been defined." />
      )
      }
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    groups: state.template.activeTemplate?.parameterGroups,
    selectedGroup: state.template.activeTemplate?.selectedGroup,
    updated: state.template.activeTemplate?.updated,
    inProgress: state.template.activeTemplate?.inProgress,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ondeleteTemplateParameterGroup: (groupId) => {
      dispatch(deleteParameterGroup(groupId));
    },
    ondeleteTemplateParameterItem: (parameterId) => {
      dispatch(deleteParameterItem(parameterId));
    },
    onSetSelectedTemplateItem: (node) => {
      dispatch(setSelectedParameter(node));
    },
    onSetSelectedGroupItem: (node) => {
      dispatch(setSelectedGroup(node));
    },
    oncreateParameterGroup: (templateId, groupName) => {
      dispatch(createParameterGroup(templateId, groupName));
    },
    onUpdateSelectedGroup: (group) => {
      dispatch(updateSelectedGroup({ group }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateParameterTreeSidebar);
